import { useCommonStore } from '@stores/common'
import { useCheckoutStore } from '@stores/checkout'

import { useCheckoutApi } from '@api/orders/checkout/index.hook'

import { show404 } from '@utils/pages/error'
import amplitudeConfig from '@config/amplitude.json'

import { trackEvent } from '@tools/amplitude'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const order = to.params?.order as string | undefined
  const notifyType = (to.query.notify_type || null) as string | null
  const validOrder: boolean = typeof order === 'string'

  if (!validOrder) return show404()

  const commonStore = useCommonStore()
  const checkoutStore = useCheckoutStore()

  const orderId = Number(order)
  const validOrderId = Number.isInteger(orderId) && orderId > 0

  if (!validOrderId) return show404()

  checkoutStore.setNotifyType(notifyType)

  void useCheckoutApi({ orderId, route: to }, {
    onStart: () =>{
      commonStore.setLoading(true)
    },
    onSuccess: () => {
      trackEvent(amplitudeConfig.events.pageViewCheckout, checkoutStore.getEventProps)
    },
    onFinish: () => {
      commonStore.setLoading(false)
    },
  })
})
